import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { getWithAuth, postWithAuth } from "../../../http";

export type DocumentSectionMappingId = string;

export interface DocumentSectionMappingPosition {
	id: string;
	position: number;
}

export interface DocumentSectionMapping {
	id: DocumentSectionMappingId;
	documentType: string;
	sectionType: string;
	singleInDocument: boolean;
	position: number;
}

export interface DraftDocumentSectionMapping {
	documentType: string;
	mappings: Omit<DocumentSectionMapping, "id">[];
}

export const loadDocumentSectionMappings = createAsyncThunk<DocumentSectionMapping[], void, AppThunkAPIType>(
	"document-section-mappings/load",
	async (_, { dispatch, rejectWithValue }) => {
		const result = await dispatch(getWithAuth({ url: "api/sys/document-section-mappings" }));
		const { payload } = result;

		if (getWithAuth.fulfilled.match(result)) {
			return payload as DocumentSectionMapping[];
		}

		return rejectWithValue(payload ?? { kind: "unknown" });
	}
);

export const syncDocumentSectionMapping = createAsyncThunk<DocumentSectionMapping[], DraftDocumentSectionMapping, AppThunkAPIType>(
	"document-section-mappings/update",
	async (mapping, { dispatch, rejectWithValue }) => {
		const result = await dispatch(postWithAuth({
			url: "api/sys/document-section-mappings",
			payload: mapping,
		}));
		const { payload } = result;

		if (postWithAuth.fulfilled.match(result)) {
			return payload as DocumentSectionMapping[];
		}

		return rejectWithValue(payload ?? { kind: "unknown" });
	}
);
